import Immutable from 'immutable'
import {
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_ERROR,
  DELETE_IMAGE_REQUEST,
  DELETE_IMAGE_SUCCESS,
  DELETE_IMAGE_ERROR
} from '../actions/image'

export default (
  state = Immutable.Map({
    inProgress: false,
    error: null
  }),
  action
) => {
  switch (action.type) {
    case UPLOAD_IMAGE_REQUEST:
    case DELETE_IMAGE_REQUEST:
      return state.set('inProgress', true).set('error', null)
    case UPLOAD_IMAGE_SUCCESS:
    case DELETE_IMAGE_SUCCESS:
      return state.set('inProgress', false)
    case UPLOAD_IMAGE_ERROR:
    case DELETE_IMAGE_ERROR:
      return state.set('inProgress', false).set('error', action.error)
    default:
      return state
  }
}
